const Footer=()=>{
return(<>
    <div style={{width:'100%',height:'35px',backgroundColor:'#81a1c1',color:'#eceff4',bottom:'0',position:'fixed',paddingTop:'5px'}}>
        © תכנון ופיתוח: <a href='mailto:ri9907ri@gmail.com?subject=מתעניין בתוכנת איחורית' style={{textDecoration:'none',color:'#eceff4'}}>רבקי אביעזר</a> ו<a href='mailto:sh7618sh@gmail.com?subject=מתעניין בתוכנת איחורית' style={{textDecoration:'none',color:'#eceff4'}}>שולמית פרידמן</a>
    </div>
</>)
}

export default Footer
